<mat-sidenav-container class="flex flex-col">
  <mat-sidenav
    id="sidenav"
    #sidenav
    mode="over"
    [fixedInViewport]="true"
    (openedChange)="openedChanged($event)"
  >
    <div class="flex flex-col">
      <div class="flex flex-col group cursor-pointer">
        <a routerLink="/" (click)="sidenav.close()" class="font-bold text-xl p-4">
          <h2>{{ school.name }}</h2>
        </a>
        <a
          class="group-hover:bg-orangeLightX text-gray-700 py-2 pl-2 font-bold flex items-center gap-2 text-sm"
          routerLink="/"
          (click)="sidenav.close()"
          >Home</a
        >
      </div>
      <ts-course-sidenav-menu (click)="sidenav.close()"></ts-course-sidenav-menu>
      <a
        class="hover:bg-orangeLightX text-gray-700 py-2 pl-2 font-bold flex items-center gap-2 text-sm"
        [href]="school?.voucher_url"
        target="_blank"
        (click)="sidenav.close()"
      >
        <mat-icon>&#xe8f6;</mat-icon>
        Gutscheine
      </a>
      @if (school?.has_trial_lesson_form) {
        <a
          class="hover:bg-orangeLightX text-gray-700 py-2 pl-2 font-bold flex items-center gap-2 text-sm"
          routerLink="/probestunde"
          (click)="sidenav.close()"
        >
          <mat-icon>&#xe572;</mat-icon>
          Probestunde
        </a>
      }
      <ts-event-sidenav-menu (click)="sidenav.close()"></ts-event-sidenav-menu>
      <!--<ts-page-sidenav-menu (click)="sidenav.close()"></ts-page-sidenav-menu>-->
      <ts-school-sidenav-menu (click)="sidenav.close()"></ts-school-sidenav-menu>
      @if (partnerSchools.length > 0) {
        <div class="mt-4 border-t pt-2">
          <h3 class="text-xs text-gray-500 uppercase tracking-wide pl-2 pb-1">Partnerschulen</h3>
          @for (partner of partnerSchools; track partner.short_name) {
            <a
              class="hover:bg-orangeLightX text-gray-700 py-2 pl-2 font-bold flex items-center gap-2 text-sm"
              [href]="'//' + partner.homepage_url"
              target="_blank"
              (click)="sidenav.close()"
            >
              <img
                style="height: 30px; width: 58px; filter: brightness(0)"
                [src]="partner.getLogoPath()"
                [alt]="'Logo der ' + partner.name"
              />
              {{ partner.name }}
            </a>
          }
        </div>
      }
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
